import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePicker.less';

class DatePicker extends Component {
  constructor(props) {
    super(props);
    this.click = this.click.bind(this);
  }

  click() {
    this.dpInput.onInputClick();
    this.dpInput.setFocus();
  }

  render() {
    const { value, onChange, ...rest } = this.props;
    return (
      <div
        className="form"
        style={{ width: '140px', position: 'relative', display: 'inline-block' }}
      >
        <ReactDatePicker
          // className="text-gray-darker"
          ref={(instance) => (this.dpInput = instance)}
          onChange={onChange}
          selected={value}
          dateFormat="dd/MM/yyyy"
          {...rest}
        />
        <i
          className="icon-calendar cursor-pointer text-gray-darker"
          onClick={this.click}
          style={{ position: 'absolute', top: 5, right: 10 }}
        />
      </div>
    );
  }
}

DatePicker.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired
};

export default DatePicker;
